import { RegexEnum } from '../../libs/enums';
import {
  mustBeFilled,
  mustBeLessThan,
  mustBeMoreThan,
  mustMatchFormat,
} from '../../libs/validators';

export const inputBirthplaceConfig = {
  description: 'Comme inscrit sur votre acte de naissance',
  label: 'Ville de naissance',
  name: 'birthplace',
  validators: {
    format: [
      mustMatchFormat(
        RegexEnum.LOCATION,
        'Veuillez utiliser uniquement des caractères alpha-numériques ou de ponctuations',
      ),
      mustBeMoreThan(1),
      mustBeLessThan(256),
    ],
    submit: mustBeFilled('Veuillez renseigner votre ville de naissance'),
  },
};
